import React, { Suspense } from 'react';
import About from './about/About.js';

const Projects = React.lazy(() => import('./projects/Projects.js'));
const Contact = React.lazy(() => import('./contact/Contact.js'));

function Home() {
  return (
    <>
      <About />
      <Suspense fallback={null}>
        <Projects />
        <Contact />
      </Suspense>
    </>
  );
}

export default Home;
